import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';

export default function Closing() {
  return (
    <section className="relative overflow-hidden bg-pink-500">
      {/* 网点背景 */}
      <div className="absolute top-0 left-0 w-[360px] h-[360px] bg-[radial-gradient(circle,rgba(255,255,255,0.14)_1.5px,transparent_1.5px)] [background-size:18px_18px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[420px] h-[420px] bg-[radial-gradient(circle,rgba(255,255,255,0.14)_1.5px,transparent_1.5px)] [background-size:18px_18px] pointer-events-none" />

      <div className="relative section-padding">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            {/* 对话气泡标签 */}
            <div className="flex justify-center mb-7">
              <div className="relative">
                <span className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-white border-2 border-gray-900 text-xs font-bold tracking-wider text-gray-900 shadow-[4px_4px_0_0_#ff9db8]">
                  <i className="ri-heart-3-fill text-pink-500" />
                  加入天天漫画
                </span>
                <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-b-2 border-r-2 border-gray-900 rotate-45" />
              </div>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              让好故事，触手可及
            </h2>
            <p className="mt-6 text-white/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
              天天漫画始终相信，好的故事值得被更多人看见。无论你是读者还是创作者，这里都有属于你的舞台。
            </p>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/creator"
                className="btn-comic border-gray-900 text-gray-900 bg-white shadow-[4px_4px_0_0_#1a1a1a] hover:bg-pink-50"
              >
                创作者平台
              </Link>
              <Link
                to="/careers"
                className="btn-comic border-gray-900 text-gray-900 bg-white shadow-[4px_4px_0_0_#1a1a1a] hover:bg-pink-50"
              >
                加入我们
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}